import React from 'react';
import PropTypes from 'prop-types';
import {
  FormattedContainer,
  FormattedDescriptionContainer,
  StyledDescriptionText,
  StyledDialogText,
  Word,
} from './StyledComponents';

export const DescriptionText = ({ className, formatText = true, children, ...props }) => {
  const text = children || '';
  if (formatText) {
    return (<FormattedDescription className={className} text={text} {...props} />);
  }
  return (<StyledDescriptionText className={className}>{text}</StyledDescriptionText>);
};

DescriptionText.propTypes = {
  className: PropTypes.string,
  formatText: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

DescriptionText.defaultProps = {
  className: '',
  formatText: true,
};

export const DialogText = ({ formatText, children, index, ...props }) => {
  const text = children || '';
  if (formatText) {
    return (<FormattedDialog text={text} index={index} {...props} />);
  }
  return (<StyledDialogText>{text}</StyledDialogText>);
};

DialogText.propTypes = {
  formatText: PropTypes.bool,
  children: PropTypes.node.isRequired,
  index: PropTypes.number,
};

DialogText.defaultProps = {
  formatText: true,
  index: 0,
};

export const FormattedDescription = ({ text, ...props }) => {
  const arrayOfWords = getFormattedWords(text);
  return (
    <FormattedDescriptionContainer {...props}>
      {arrayOfWords.map((p) => (
        <Word {...p}>{p.text}</Word>
      ))}
    </FormattedDescriptionContainer>
  );
};

FormattedDescription.propTypes = {
  text: PropTypes.string,
};

FormattedDescription.defaultProps = {
  text: '',
};

export const FormattedDialog = ({ text = '', index }) => {
  const arrayOfWords = getFormattedWords(text);
  return (
    <FormattedContainer
      data-testid={`login-modal-progress-message-${index + 1}`}
    >
      {arrayOfWords.map((p) => (
        <Word {...p}>{p.text}</Word>
      ))}
    </FormattedContainer>
  );
};

FormattedDialog.propTypes = {
  text: PropTypes.string,
  index: PropTypes.number,
};

FormattedDialog.defaultProps = {
  text: '',
  index: 0,
};

const getFormattedWords = (fullText) => {
  const EMPTY_SPACE = ' ';
  const words = fullText.split(EMPTY_SPACE);

  let isBoldLockOn = false;
  const formattedText = words.map((word, index) => {
    const originalText = word;
    const withoutAsteriks = word.replace(/\*/g, '');

    const isThisBold = originalText.includes('*');
    // check if originalText has more than 1 asterisk
    // handles cases for '*foo*' where we don't want to toggle bold lock
    const hasOneAsterisk = (originalText.match(/\*/g) || []).length === 1;
    if (isThisBold && hasOneAsterisk) {
      isBoldLockOn = !isBoldLockOn;
    }

    return {
      key: `key-${originalText}-${index}`,
      text: withoutAsteriks,
      isBold: isThisBold || isBoldLockOn,
      needsMargin: index !== words.length - 1,
    };
  });
  return formattedText;
};
